import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_ENV === "PROD"
        ? "https://kernel.bookingjini.com/extranetv4/"
        : "https://dev.kernel.bookingjini.com",
})